import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';
import WeekDaysSelect from './WeekDaysSelect';
import PlaceRolesSelect from './PlaceRolesSelect';

import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class PlaceRolesForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Kód" >
          {getFieldDecorator('code', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat řetězec!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Název" >
          {getFieldDecorator('name', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat řetězec!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Čas od [m] (0-1440)" >
          {getFieldDecorator('timeFrom', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={0} max={1440} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Čas do [m] (0-1440)" >
          {getFieldDecorator('timeTo', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={1440} />
          )}
        </FormItem>        
        <FormItem
          {...formItemLayout}
          label="Dny v týdnu" >
          {getFieldDecorator('weekdays', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <WeekDaysSelect mode="multiple" onChange={(value) => { this.props.form.setFieldsValue({ weekdays: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Priorita" >
          {getFieldDecorator('priority', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={999} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title="Vytvoření nové role parkovacího místa"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(PlaceRolesForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/PlaceRolesForm.js